import { render, staticRenderFns } from "./CostOfSoldGoods.vue?vue&type=template&id=f62648b0"
import script from "./CostOfSoldGoods.vue?vue&type=script&lang=js"
export * from "./CostOfSoldGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports